import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  countButton: {
    width: 130,
    height: 36,
    [theme.breakpoints.down('lg')]: {
      width: 96,
      height: 34,
    },
    [theme.breakpoints.down('md')]: {
      width: 96,
      height: 24,
    },
  },
}));
